import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-editar-operacion',
  templateUrl: './editar-operacion.component.html',
  styleUrls: ['./editar-operacion.component.scss']
})
export class EditarOperacionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
